import { makeAutoObservable } from 'mobx'

export class PriceStore {
  private _raw ?: number
  private _value ?: number

  constructor() {
    makeAutoObservable(this)
  }

  get raw(): number | undefined {
    return this._raw
  }

  set raw(value: number | undefined) {
    this._raw = value
  }

  get value(): number | undefined {
    return this._value
  }

  reset() {
    this._raw = undefined
    this._value = undefined
  }

  apply() {
    this._value = this._raw
  }

  unapply() {
    this._raw = this._value
  }
}
